__turbopack_context__.v({
  "course-preview-modal-title": "course-preview-module-scss-module__xs0eTG__course-preview-modal-title",
  "current-preview-row": "course-preview-module-scss-module__xs0eTG__current-preview-row",
  "icon": "course-preview-module-scss-module__xs0eTG__icon",
  "preview-intro": "course-preview-module-scss-module__xs0eTG__preview-intro",
  "preview-row": "course-preview-module-scss-module__xs0eTG__preview-row",
  "preview-row-title": "course-preview-module-scss-module__xs0eTG__preview-row-title",
  "preview-rows": "course-preview-module-scss-module__xs0eTG__preview-rows",
  "preview-thumbnail": "course-preview-module-scss-module__xs0eTG__preview-thumbnail",
  "preview-thumbnail-wrapper": "course-preview-module-scss-module__xs0eTG__preview-thumbnail-wrapper",
  "previews": "course-preview-module-scss-module__xs0eTG__previews",
  "separation-text": "course-preview-module-scss-module__xs0eTG__separation-text",
  "video-player-loading": "course-preview-module-scss-module__xs0eTG__video-player-loading",
  "video-preview": "course-preview-module-scss-module__xs0eTG__video-preview",
});
